import React from "react";
import { useLocalization } from "@fluent/react";
import type { SupportContact } from "byzantine/src/types/models/v1/Support.types";
import type {
  SupportFaqCategory,
  SupportLink,
} from "byzantine/src/types/SettingLocalizers.types";
import ContactUsList from "./ContactUsList";
import FAQList from "./FAQList";
import QuickLinkList from "./QuickLinkList";

import "./SupportPageLayout.css";

type SupportPageLayoutProps = {
  supportContacts: SupportContact[];
  supportFAQs: SupportFaqCategory[];
  supportLinks: SupportLink[];
};

export default function SupportPageLayout({
  supportContacts,
  supportFAQs,
  supportLinks,
}: SupportPageLayoutProps) {
  const { l10n } = useLocalization();
  return (
    <>
      <div className="section-header-background">
        <div className="legacyGrid legacyGrid--centerAligned legacyGrid-container">
          <div className="legacyGrid-col--16 legacyGrid-col--leftAligned">
            <h2 className="section-header">{l10n.getString("header-support")}</h2>
          </div>
        </div>
      </div>
      <div className="legacyGrid legacyGrid--centerAligned legacyGrid-container">
        <div className="legacyGrid-col--16 legacyGrid-col--leftAligned">
          <div className="support-page-layout">
            <ContactUsList contacts={supportContacts} />
            <FAQList categories={supportFAQs} />
            <QuickLinkList links={supportLinks} />
          </div>
        </div>
      </div>
    </>
  );
}
